import { S } from '../regureStyles';

// ─── Dashboard ────────────────────────────────────────────
// ─── Severity color map ───────────────────────────────────
const SEVERITY_COLORS = { critical: '#dc2626', high: '#ea580c', medium: '#d97706', low: '#16a34a' };

const RiskSignals = ({
  t,
  history,
  displaySignals,
  handleAcknowledge,
  displayCritical,
  displayHigh,
  displayMedium,
  signalFlash,
  hasData,
  low,
  loading,
  ackingId,
}) => {
  return (
    <div className={signalFlash ? 'dash-flash' : ''} style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 16, padding: 24 }}>
      {/* Widget header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: S.textPrimary }}>{t('dashboard.riskSignals')}</div>
        <button
          onClick={() => history.push('/risk-signals')}
          style={{
            fontSize: 12,
            color: S.burgundy,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          }}
        >
          {t('common.viewAll')}
          <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <polyline points='9 18 15 12 9 6' />
          </svg>
        </button>
      </div>

      {/* Severity summary pills */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        {[
          { label: `${displayCritical} ${t('severity.critical')}`, color: '#dc2626' },
          { label: `${displayHigh} ${t('severity.high')}`, color: '#ea580c' },
          { label: `${displayMedium} ${t('severity.medium')}`, color: '#d97706' },
          { label: `${hasData ? low : '—'} ${t('severity.low')}`, color: '#16a34a' },
        ].map(({ label, color }) => (
          <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
            {label}
          </div>
        ))}
      </div>

      {/* Signal list */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0, border: `1px solid ${S.borderLight}`, borderRadius: 12, overflow: 'hidden' }}>
        {displaySignals.length === 0 ? (
          <div style={{ padding: '24px', textAlign: 'center', color: S.textMuted, fontSize: 13 }}>{loading ? t('common.loading') : t('screens.dashboard.noActiveRiskSignals')}</div>
        ) : (
          SEVERITY_COLORS &&
          displaySignals.map((sig, i) => {
            const color = SEVERITY_COLORS[sig.severity] || '#64748b';
            const claimNum = sig.claim?.claimNumber || sig.claim;
            const claimant = sig.claim?.claimant?.name || sig.claim?.['claimant.name'] || '';
            return (
              <div
                key={sig._id || `synthetic-${i}`}
                style={{
                  padding: '14px 16px',
                  borderBottom: i < displaySignals.length - 1 ? `1px solid ${S.borderLight}` : 'none',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 12,
                  background: i % 2 === 0 ? '#fff' : S.bgCard,
                }}
              >
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0, marginTop: 5 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: S.textPrimary }}>
                    {sig.title || sig.type?.replace(/_/g, ' ')} — {claimNum}
                  </div>
                  <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{sig.description}</div>
                  {claimant && <div style={{ fontSize: 11, color: S.textMuted, marginTop: 2 }}>{claimant}</div>}
                </div>
                <button
                  onClick={() => handleAcknowledge(sig._id)}
                  disabled={ackingId === sig._id}
                  style={{
                    padding: '5px 12px',
                    background: 'rgba(128,0,32,0.06)',
                    border: `1px solid rgba(128,0,32,0.2)`,
                    borderRadius: 6,
                    fontSize: 11,
                    fontWeight: 600,
                    color: S.burgundy,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    opacity: ackingId === sig._id ? 0.5 : 1,
                  }}
                >
                  {t('common.acknowledge')}
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default RiskSignals;
